import className from "~/kernel/styling/className";
import Icon from "../Icon";

type BannerProps = {
  variant?: "info" | "error" | "success" | "warning" | "dark";
  children: string;
  onDismiss?: () => void;
};

export function Banner({ onDismiss, children, variant = "info" }: BannerProps) {
  return (
    <div
      className={className(
        "text-center p-2 w-full flex flex-row justify-between gap-3",
        () => {
          switch (variant) {
            case "info":
              return "bg-info text-white";
            case "warning":
              return "bg-warning text-slate-800";
            case "error":
              return "bg-error text-white";
            case "success":
              return "bg-positive text-white";
            case "dark":
              return "bg-slate-800 text-white";
          }
        },
      )}
      role="alert"
    >
      <div></div>
      <div>{children}</div>
      {onDismiss ? (
        <button onClick={() => onDismiss()}>
          <Icon name="xmark" />
        </button>
      ) : null}
    </div>
  );
}
